import React,{useEffect,useState} from 'react'
import { useNavigate } from 'react-router-dom';
import { getCountries, getCities, getClasses, getSchools,getStudyCenter, getCountryCode, getCourses, RegisterUser, sendOtpApi, vefificationPasskeySendApi } from '../../actions/RegisterAction';
import swal from 'sweetalert';
import Select from 'react-select'
import { countryId } from '../../config/Constant';
// import { salesforceSendFormNumber } from '../../actions/StudentAction';
import moment from 'moment/moment';
import OtpModal from '../common/OtpModel';

const RegisterForm = ({utmData}) => {
    const navigate = useNavigate();
    const [country,setCountry] = useState({value:'',options:[],error:''})
    const [countryCode,setCountryCode] = useState({value:'',options:[],error:''})
    const [email,setEmail] = useState({value:'',error:''})
    // const [confirmEmail,setConfirmEmail] = useState({value:'',error:''})
    const [fullName,setFullName] = useState({value:'',error:''})
    const [password,setPassword] = useState({value:'',error:''})
    const [confirmPassword, setConfirmPassword] = useState({ value: '', error: ''});
    const [mobileNumber,setMobileNumber] = useState({value:'',error:''})
    const [classes,setClasses] = useState({value:'',options:[],error:''})
    const [dob,setDob] = useState({value:'',error:''})
    const [fatherName,setFatherName] = useState({value:'',error:''})
    const [motherName,setMotherName] = useState({value:'',error:''})
    const [cities,setCities] = useState({value:'',options:[],error:''})
    const [otherCity,setOtherCity] = useState({value:'',error:''})
    const [schools, setSchools] = useState({value: '', options: [] , error: ''});
    const [otherSchoolName, setOtherSchoolName] = useState({ value: '', error: '' });
    const [isOtherSchool, setIsOtherSchool] = useState(false)
    const [courses, setCourses] = useState({ value: '', error: '', options: [] });
    const [studyCenter, setStudyCenter] = useState({ value: '', options: [],error: '' });

    const [showOtherCity,setShowOtherCity] = useState(false)

    const [showPassword,setShowPassword] = useState(false)

    const [otpModel,setOtpModel] = useState(false)
    const [otpFieldValue,setOtpFieldValue] = useState({value:'',error:''});

    const [loading,setLoading] = useState(false);
    const [otpLoading,setOtpLoading] = useState(false);

    const currentDate = moment().format('YYYY-MM-DD');
    const minDate = moment(currentDate).subtract(5, 'years').format('YYYY-MM-DD');

   
    useEffect(() => {

        try {
            getCountries().then((res) => {
                if(res.status){
                    setCountry((prev) => ({...prev,options:res.data}))
                }
            })
        } catch (error) {
            console.log(error)
        }
            
        try {
            getClasses().then((res) => {
                if(res.status){
                    setClasses((prev) => ({...prev,options:res.data}))
                }
            })
        } catch (error) {
            console.log('city error',error)
        }
           

    },[])

    const countryChangeHandler = async (e) => {
        try {
          setCountry({ ...country, value: e, error: '' });
          setOtherCity({ ...otherCity, value: '', error: '' });
          setShowOtherCity(false);
          setOtherSchoolName({ ...otherCity, value: '', error: '' });
          setIsOtherSchool(false);
      
          // Country code
          try {
            const countryRes = await getCountryCode(e.id);
            if (countryRes.status) {
                const staticData = {
                    id: 10,
                    isd_code: "+91",
                    iso_code: "IN"
                  };
                  const updatedOptions = [staticData, ...countryRes.data];

              setCountryCode({
                ...countryCode,
                options: updatedOptions,
                value: updatedOptions.length === 1 ? updatedOptions[0] : '',
              });
            }
          } catch (error) {
            console.error('Error getting country code:', error);
          }
      
          // Cities
          try {
            const citiesRes = await getCities(e.id);
            if (citiesRes.status) {
              setCities({
                ...cities,
                options: citiesRes.data,
                value: citiesRes.data.length === 1 ? citiesRes.data[0] : '',
              });
            }
          } catch (error) {
            console.error('Error getting cities:', error);
          }
      
          // Schools
          // Schools
          try {
            await  getSchools({city_id:'',cid:e.id})
              .then((res) => {
                  setSchools({ ...schools, options:res.data,value:res.data.length===1?res.data[0]:''})
              });
          } catch (error) {
              console.log('schools..',error)
          }
      
          // Study Center
          try {
            const studyCenterRes = await getStudyCenter(e.id);
            setStudyCenter({
              ...studyCenter,
              options: studyCenterRes.data,
              value: '',
            });
          } catch (error) {
            console.error('Error getting study center:', error);
          }
      
          // Courses
          try {
            const courseRes = await getCourses(
              e.id,
              classes.value,
              studyCenter.value.id
            );
            setCourses({
              ...courses,
              options: courseRes.data,
              value: '',
            });
          } catch (error) {
            console.error('Error getting courses:', error);
          }
        } catch (error) {
          console.error('Error in countryChangeHandler:', error);
        }
      };
      

    const handleClassChange = (e) => {
        setClasses({ ...classes, value: e, error: '' });

        getCourses(country.value.id,e.id,studyCenter.value.id)
        .then((res) => {
            setCourses({ ...courses, options: res.data,value:res.data.length===1?res.data[0]:''   })
        });
    }

    const handleCountryCode = (e) => {
        setCountryCode({ ...countryCode, value: e, error: '' });
        setMobileNumber({ ...mobileNumber, value:'', error: '' })
    }

    // Handle manual country code entry for Non-GCC (id: 14)
    const handleManualCountryCode = (e) => {
        let value = e.target.value.replace(/\D/g, '');
        if (value.length > 3) {
            value = value.slice(0, 3);
        }
        const normalized = value ? `+${value}` : '';
        setCountryCode({
            ...countryCode,
            value: { id: country.value.id, isd_code: normalized },
            error: '',
        });
    };

    
    const cityChangeHandler = async (e) => {
        const cVal = e.id;
        setCities({...cities,value:e,error:''})
        setOtherCity({...otherCity,value:'',error:''})
        if(cVal ===0){
            setShowOtherCity(true)
        }
        else{
            setShowOtherCity(false)
        }

        // Schools
        try {
            // uncomment to send city id
            const schoolsRes = await getSchools({city_id:e.id,cid:country.value.id});
            // const schoolsRes = await getSchools({city_id:'',cid:country.value.id});
            setSchools({
              ...schools,
              options: schoolsRes.data,
              value: schoolsRes.data.length === 1 ? schoolsRes.data[0] : '',
            });
          } catch (error) {
            console.error('Error getting schools:', error);
          }
    }

    const handleSchoolChange = (e) => {
        const sVal = e.id
        setSchools({ ...schools, value: e, error: '' });
        setOtherSchoolName({ ...otherSchoolName, value: '', error: '' })
        if (sVal === 0) {
            setIsOtherSchool(true)
        }
        else {
            setIsOtherSchool(false)
        }
    }

    const handleStudyCenterChange = (e) => {
        setStudyCenter({ ...studyCenter, value: e, error: '' });
        setCourses({ ...courses,  error: '' });
        try {
            getCourses(country.value.id,classes.value,e.id)
            .then((res) => {
                setCourses({ ...courses, options:res.data,value:res.data.length===1?res.data[0]:''  })
                if(res?.data?.length === 0){
                    swal('No courses available for the grade at the selected center','','warning')
                }
            });
        } catch (error) {
            console.log('course error',error)
        }
    }

    const handleCoursesChange = (e) => {
        setCourses({ ...courses, value: e, error: '' });
    }


    const validation = () => {
        const nameRegex = /^[a-zA-Z() ]+$/;
        let mobileRegex = /^\d+(\.\d{1,2})?$/;
        let formIsValid = true

        if (!country.value) {
            formIsValid = false
            let msg = "Please select country"
            setCountry({ ...country, error: msg })
        }

        if (!studyCenter.value) {
            formIsValid = false
            let msg = "Please select study center"
            setStudyCenter({ ...studyCenter, error: msg })
        }
        if (!courses.value) {
            formIsValid = false
            let msg = "Please select course"
            setCourses({ ...courses, error: msg })
        }

        if (!cities.value) {
            formIsValid = false
            let msg = "Please select city"
            setCities({ ...cities, error: msg })
        }
        if(cities.value ==='0'){
            formIsValid = false
            let msg = "Please enter other city name"
            setOtherCity({ ...otherCity, error: msg })
        }

        if (cities.value.id === 0) {
            formIsValid = true
            setCities({ ...cities, error: '' })
            if (!otherCity.value) {
                formIsValid = false
                setOtherCity({ ...otherCity, error: 'Please provide other city name' })
            }

            if (otherCity.value !== '' && otherCity.value.length < 3) {
                formIsValid = false
                let msg = "Min 3 Character Length"
                setOtherCity({ ...otherCity, error: msg })
            }
            else if (otherCity.value !== '' && otherCity.value.length >= 50) {
                formIsValid = false
                let msg = "Max 50 Character Length"
                setOtherCity({ ...otherCity, error: msg })
            }
        }

        if (!classes.value) {
            formIsValid = false
            let msg = "Please select class"
            setClasses({ ...classes, error: msg })
        }

         // School (optional)
         if (schools.value?.id===0) {
            formIsValid = true
            setSchools({ ...schools, error: '' })
                if(!otherSchoolName.value){
                    formIsValid = false
                    setOtherSchoolName({...otherSchoolName,error:'Please provide other school name'})
                }

                 // Other school
            if (otherSchoolName.value !== '' && otherSchoolName.value.length < 3) {
                formIsValid = false
                let msg = "Min 3 Character Length"
                setOtherSchoolName({ ...otherSchoolName, error: msg })
            }
            else if (otherSchoolName.value !== '' && otherSchoolName.value.length >= 50) {
                formIsValid = false
                let msg = "Max 50 Character Length"
                setOtherSchoolName({ ...otherSchoolName, error: msg })
            }
        }


            // Full Name
            if (!fullName.value) {
                formIsValid = false
                let msg = "Please enter name"
                setFullName({ ...fullName, error: msg })
            }
            else if (fullName.value.length < 3) {
                formIsValid = false
                let msg = "Min 3 Character Length";
                setFullName({ ...fullName, error: msg })
            }
            else if (fullName.value.length > 64) {
                formIsValid = false
                let msg = "Max 64 Character Length";
                setFullName({ ...fullName, error: msg })
            }
            else if (!nameRegex.test(fullName.value)) {
                formIsValid = false
                let msg = "Only Aplhabets should be acceptable No Numbers, Special Characters etc";
                setFullName({ ...fullName, error: msg })
            }
    
            // Email validation
            if (!email.value) {
                formIsValid = false
                let msg = "Please enter your email"
                setEmail({ ...email, error: msg })
            }

            // if (confirmEmail.value !== email.value) {
            //     formIsValid = false
            //     let msg = "Email is not matching"
            //     setConfirmEmail({ ...confirmEmail, error: msg })
            // }
    
            if (email.value.length < 3) {
                formIsValid = false
                let msg = "Min 3 Character Length"
                setEmail({ ...email, error: msg })
            }
            if (email.value.length > 64) {
                formIsValid = false
                let msg = "Max 64 Character Length"
                setEmail({ ...email, error: msg })
            }
    
            if (typeof email.value !== "undefined") {
                var pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
                if (!pattern.test(email.value)) {
                    formIsValid = false
                    let msg = "Enter a valid Email ID (Ex: abc@gmail.com)"
                    setEmail({ ...email, error: msg })
                }
            }
    
    
            // Phone number
            if (!mobileNumber.value) {
                formIsValid = false
                let msg = "Please enter your mobile number"
                setMobileNumber({ ...mobileNumber, error: msg })
            }

        if (!mobileRegex.test(mobileNumber.value)) {
                formIsValid = false
                let msg = "Enter a valid Mobile Number"
                setMobileNumber({ ...mobileNumber, error: msg })
            }

        const startsWithZero = mobileNumber.value && mobileNumber.value.startsWith('0')
        if (startsWithZero) {
            formIsValid = false
            let msg = "Mobile number should not start with 0"
            setMobileNumber({ ...mobileNumber, error: msg })
        }

        // Reject dummy mobile numbers like 00000000, 11111111, 99999999
        if (mobileNumber.value && /^(\d)\1+$/.test(mobileNumber.value)) {
            formIsValid = false
            let msg = "Please enter a valid mobile number"
            setMobileNumber({ ...mobileNumber, error: msg })
        }
            

            
        if(country.value.id === 14){
            // Country code validation for manual input - mandatory
            const manualCodeDigits = (countryCode.value?.isd_code || '').replace('+','');
            if(!manualCodeDigits || manualCodeDigits.trim() === ''){
                formIsValid = false
                let msg = "Please enter country code"
                setCountryCode({ ...countryCode, error: msg })
            }
            else if(manualCodeDigits.length < 2 || manualCodeDigits.length > 3){
                formIsValid = false
                let msg = "Country code must be 2-3 digits"
                setCountryCode({ ...countryCode, error: msg })
            }

            // Non-GCC: mobile length 6 to 12
            if(!startsWithZero && mobileNumber.value.length < 6){
                formIsValid = false
                let msg = "Min 6 Digit Length"
                setMobileNumber({ ...mobileNumber, error: msg })
            }
            else if(!startsWithZero && mobileNumber.value.length > 12){
                formIsValid = false
                let msg = "Max 14 Digit Length"
                setMobileNumber({ ...mobileNumber, error: msg })
            }
        }
        else{
                if(!countryCode.value || !countryCode.value.isd_code){
                    formIsValid = false
                    let msg = "Please select country code"
                    setCountryCode({ ...countryCode, error: msg })
                }
                else if(countryCode.value.id === 10){
                    if(!startsWithZero && mobileNumber.value.length < 10){
                        formIsValid = false
                        let msg = "Min 10 Digit Length"
                        setMobileNumber({ ...mobileNumber, error: msg })
                    }
                    else if(!startsWithZero && mobileNumber.value.length > 10){
                        formIsValid = false
                        let msg = "Max 10 Digit Length"
                        setMobileNumber({ ...mobileNumber, error: msg })
                    }
                }
                else if(countryCode.value.id !==10){
                if(country.value.id ===1 || country.value.id ===2 || country.value.id ===4 || country.value.id ===5){
                    if(!startsWithZero && mobileNumber.value.length < 8){
                        formIsValid = false
                        let msg = "Min 8 Digit Length"
                        setMobileNumber({ ...mobileNumber, error: msg })
                    }
                    else if(!startsWithZero && mobileNumber.value.length > 8){
                        formIsValid = false
                        let msg = "Max 8 Digit Length"
                        setMobileNumber({ ...mobileNumber, error: msg })
                    }
                }

                else if(country.value.id ===6){
                    if(!startsWithZero && mobileNumber.value.length < 9){
                        formIsValid = false
                        let msg = "Min 9 Digit Length"
                        setMobileNumber({ ...mobileNumber, error: msg })
                    }
                    else if(!startsWithZero && mobileNumber.value.length > 9){
                        formIsValid = false
                        let msg = "Max 9 Digit Length"
                        setMobileNumber({ ...mobileNumber, error: msg })
                    }
                }
        
                else if(country.value.id ===7){
                    if(!startsWithZero && mobileNumber.value.length < 9){
                        formIsValid = false
                        let msg = "Min 9 Digit Length"
                        setMobileNumber({ ...mobileNumber, error: msg })
                    }
                    else if(!startsWithZero && mobileNumber.value.length > 10){
                        formIsValid = false
                        let msg = "Max 10 Digit Length"
                        setMobileNumber({ ...mobileNumber, error: msg })
                    }
                }
            }
        }

            if (!dob.value) {
                formIsValid = false
                let msg = "Please select date of birth"
                setDob({ ...dob, error: msg })
            }

            // Password
        const passValue = password.value

        if (!password.value) {
            formIsValid = false
            let msg = "Please enter your password"
            setPassword({ ...password, error: msg })
        }
        if (/[ '"&]/.test(passValue)) {
            formIsValid = false
            let msg = "Password must not contain spaces, &, -, single quotes, or double quotes"
            setPassword({ ...password, error: msg })
        }
        if (password.value.length < 8) {
            formIsValid = false
            let msg = "Password must contain at least 8 characters"
            setPassword({ ...password, error: msg })
        }

        // confirm pass
        if (!confirmPassword.value) {
            formIsValid = false
            let msg = "Please confirm your password"
            setConfirmPassword({ ...confirmPassword, error: msg })
        }
        if (confirmPassword.value !== password.value) {
            formIsValid = false
            let msg = "Password is not matching"
            setConfirmPassword({ ...confirmPassword, error: msg })
        }


            if(formIsValid){
                setEmail({...email,error:''})
                // setConfirmEmail({...confirmEmail,error:''})
                setFullName({...fullName,error:''})
                setMobileNumber({...mobileNumber,error:''})
                setClasses({...classes,error:''})
                setDob({...dob,error:''})
                setFatherName({...fatherName,error:''})
                setMotherName({...motherName,error:''})
                setPassword({...password,error:''})
                setConfirmPassword({ ...confirmPassword, error: '' })
                setCountry({...country,error:''})
                setCities({...cities,error:''})
                setOtherCity({...otherCity,error:''})
                setSchools({...schools,error:''})
                setOtherSchoolName({...otherSchoolName,error:''})
                setStudyCenter({ ...studyCenter, error: '' })
                setCourses({ ...courses, error: '' })
            }

            return formIsValid;

    }

    const getDataObject = () => ({
        email: email.value,
        name: fullName.value,
        mobile_no: mobileNumber.value,
        class_id: classes.value.id,
        dob: dob.value,
        country_id: country.value.id,
        city_id: cities.value.id,
        other_city: otherCity.value || '',
        school_id: schools.value?.id ?? null,
        other_school: schools.value?.id === 0 ? otherSchoolName.value : '',
        country_code: countryCode.value.isd_code,
        center_id: studyCenter.value.id,
        course_id: courses.value.id,
        password: password.value,
        utms:utmData
    });
    
    const sendOtpHandler = async () => {
        const data = getDataObject();
        const withNewData = { ...data, verification_code: Number(otpFieldValue.value) };
        setOtpLoading(true)
        try {
            const otpResponse = await vefificationPasskeySendApi(withNewData);

            if (otpResponse.status) {
                const registerResponse = await RegisterUser(data);
    
                if (registerResponse.status) {
                    setLoading(false);
                    sessionStorage.setItem('token', registerResponse.token);
    
                    swal('REGISTERED SUCCESSFULLY', '', 'success');
                    navigate('/student/dashboard');
                } else {
                    swal(registerResponse.message, 'Try again', 'error');
                    setLoading(false);
                }
            }
            else{
                setOtpLoading(false)
                setOtpFieldValue({value:''})
                swal('Failed to verify. Please check the passkey or request a new passkey.','Try Again!','error');
            }
        } catch (error) {
            console.error('Error during OTP or registration:', error);
            setLoading(false);
            setOtpLoading(false)
            setOtpFieldValue({value:''})
            swal('Something went wrong! Try again.', '', 'error');
        }
    };

    
    const onSubmit = async (e) => {
        // e.preventDefault();
        if (validation()) {
            setLoading(true);
            const data = getDataObject();
            try {
                const otpResponse = await sendOtpApi(data);
                if (otpResponse.status) {
                    setOtpModel(true);
                } else {
                    swal(otpResponse.message,'', 'error');
                }
            } catch (error) {
                console.error('Error sending OTP:', error);
                swal('We couldn’t send the WhatsApp passkey at the moment. Please try again after some time.', '', 'error');
            } finally {
                setLoading(false);
            }
        }
    };
    

    const handleViewPassword = () => {
        setShowPassword(!showPassword)
    }
    


  return (
        <>
        {
            otpModel && (
                <OtpModal  
                setOtpModel={setOtpModel} 
                otpFieldValue={otpFieldValue} 
                setOtpFieldValue={setOtpFieldValue}
                otpLoading={otpLoading}
                onSubmit={onSubmit}
                setOtpLoading={setOtpLoading}
                sendOtpHandler={sendOtpHandler} />
            )
        }

        <form  className="row gy-2 mt-2">
                            <div className="col-md-6 mb-3">
                            <label className="form-label">Country<span>*</span></label>

                             <Select
                            className='search-select-dropdown'
                            name="country"
                            value={country.value}
                            placeholder="Select Country"
                            options={country.options}
                            onChange={countryChangeHandler}
                            getOptionLabel={x => x.name}
                            getOptionValue={x => x.id}
                            />
                            {country?.error.length > 0 && <small className="invalid-field text-danger fw-semibold mt-1">{country.error}</small>}
                        </div>

                     
                      
                        <div className="col-md-6 mb-3">
                            <label className="form-label">Full Name<span>*</span></label>
                            <input type="text" value={fullName.value} 
                            onChange={(e) =>{
                                let value = e.target.value
                                value = value.replace(/[^A-Za-z- ]/ig, '')   
                                setFullName({ ...fullName, value: value, error: '' });
                            }
                            } 
                            className="form-control"  
                            placeholder="Full Name"/>
                            {fullName?.error.length > 0 && <small className="invalid-field text-danger fw-semibold mt-1">{fullName.error}</small>}
                        </div>

                        <div className="col-md-6 mb-3">
                            <label className="form-label">Email address<span>*</span></label>
                            <input type="email" value={email.value} onChange={e => setEmail({...email,value:e.target.value,error:''})} className="form-control"  placeholder="example@gmail.com"/>
                            {email?.error.length > 0 && <small className="invalid-field text-danger fw-semibold mt-1">{email.error}</small>}

                        </div>
                        
                            <div className="col-md-6 mb-3">
                            <label className="form-label">{country.value.id &&country.value.id === countryId.UAE  ? "Emirates" :'City'}<span>*</span></label>
                            <Select
                                className='search-select-dropdown'
                                name="cities"
                                value={cities.value}
                                placeholder={`${country.value.id &&country.value.id === countryId.UAE  ? "Select Emirates" :'Select City'}`}
                                options={cities.options}
                                onChange={cityChangeHandler}
                                getOptionLabel={x => x.name}
                                getOptionValue={x => x.id}
                            />
                            {cities.error.length > 0 && <small className="invalid-field text-danger fw-semibold mt-1">{cities.error}</small>}
                        </div>
                        {showOtherCity && 
                        <div className="col-md-6 mb-3">
                            <label  className="form-label">Other City<span>*</span></label>
                            <input type="text"  value={otherCity.value} 
                            onChange={e => {
                                let value = e.target.value
                                value = value.replace(/[^A-Za-z- ]/ig, '') 
                                setOtherCity({...otherCity,value:value,error:''})
                                }
                            }  
                            className="form-control"  placeholder="Enter Your City Name"/>
                            {otherCity?.error.length > 0 && <small className="invalid-field text-danger fw-semibold mt-1">{otherCity.error}</small>}
                        </div>
                        }
                        <div className="col-md-6 mb-3">
                            <div className="row gx-3">
                                <div className="col-2 mobile_code_width">
                                    <label className="form-label">Country code<span>*</span></label>
                                    {country.value?.id === 14 ? (
                                        <div className="d-flex align-items-center custom_country_code_input">
                                            <span className="me-1 fw-semibold">+</span>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Code"
                                                value={countryCode.value?.isd_code?.replace('+', '') || ''}
                                                onChange={handleManualCountryCode}
                                            />
                                        </div>
                                    ) : (
                                        <Select
                                            className='search-select-dropdown'
                                            name="cities"
                                            value={countryCode.value}
                                            placeholder='ISD Code'
                                            options={countryCode.options}
                                            isDisabled={false}
                                            onChange={handleCountryCode}
                                            getOptionLabel={x => x.isd_code}
                                            getOptionValue={x => x.id}
                                        />
                                    )}
                                    {countryCode?.error?.length > 0 && <small className="invalid-field text-danger fw-semibold mt-1">{countryCode.error}</small>}
                                </div>

                                <div className="col-7 col-lg-7 mb-3">
                                    <label className="form-label">Mobile Number <span>*</span> 
                                    {/* <small>(Max 10 digits, Do not add country code or '0')</small> */}
                                    </label>
                                    <div className="register__mobile">
                                            <input type="text"  value={mobileNumber.value} 
                                            onChange={(e) =>{
                                                let value = e.target.value
                                                value = value.replace(/\D/g, '')
                                                let maxLen = 15
                                                if (country.value?.id === 14) {
                                                    maxLen = 12
                                                } else if (countryCode.value?.id === 10) {
                                                    maxLen = 10
                                                } else if ([1,2,4,5].includes(country.value?.id)) {
                                                    maxLen = 8
                                                } else if (country.value?.id === 6) {
                                                    maxLen = 9
                                                } else if (country.value?.id === 7) {
                                                    maxLen = 10
                                                }
                                                value = value.slice(0, maxLen)
                                                setMobileNumber({...mobileNumber,value:value,error:''})
                                            }} 
                                            className="form-control" placeholder="Mobile Number"/>

                                            {/* <div className="verify__mobileLink" onClick={e => setOtpField(true)}> 
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-scan-search"><path d="M3 7V5a2 2 0 0 1 2-2h2"/><path d="M17 3h2a2 2 0 0 1 2 2v2"/><path d="M21 17v2a2 2 0 0 1-2 2h-2"/><path d="M7 21H5a2 2 0 0 1-2-2v-2"/><circle cx="12" cy="12" r="3"/><path d="m16 16-1.9-1.9"/></svg>
                                             Verify</div> */}
                                    </div>
                                    {mobileNumber?.error.length > 0 && <small className="invalid-field text-danger fw-semibold mt-1">{mobileNumber.error}</small>}
                                    
                                </div>
                                {/* <div className="col-12">
                                {otpField && (
                                        <div className="otp__field_wrapper d-flex align-items-center mt-2 me-lg-1">
                                            <input type="text"  value={otpNumber.value} 
                                            onChange={(e) =>{
                                                let value = e.target.value
                                                value = value.replace(/\D/g, '')   
                                                setOtpNumber({...otpNumber,value:value,error:''})
                                            }} 
                                            style={{width:'60%'}}
                                            className="form-control" placeholder="Enter Otp"/>
                                            <button className="btn ms-2 mt-0 btn-secondary" onClick={verifyOtpHandler}>SEND OTP</button>
                                        </div>
                                    )}
                                </div> */}
                            </div>
                        </div>

                        <div className="col-md-6 mb-3">
                            <label className="form-label">Date of Birth<span>*</span> <small className="text-primary fw-bold">(DD/MM/YYYY)</small></label>
                            <input type="date"  max={minDate}   value={dob.value} onChange={e => setDob({...dob,value:e.target.value,error:''})}  className="form-control" />
                            {dob?.error.length > 0 && <small className="invalid-field text-danger fw-semibold mt-1">{dob.error}</small>}
                        </div>


                        <div className="w-100 border my-3 border-bottom-0"></div>
                        
                        <div className="w-100"></div>
                        
                        <div className="col-md-6 mb-3">
                            <label className="form-label">Class Moving to in Session 2026-27<span>*</span> </label>
                            <Select
                                className='search-select-dropdown'
                                name="class"
                                value={classes.value}
                                placeholder='Select class'
                                options={classes?.options}
                                onChange={handleClassChange}
                                getOptionLabel={x => x.name}
                                getOptionValue={x => x.id}
                            />
                            {classes?.error.length > 0 && <small className="invalid-field text-danger fw-semibold mt-1">{classes.error}</small>}
                        </div>

                        <div className="col-md-6 mb-3">
                            <label className="form-label">School</label>
                            <Select
                                className='search-select-dropdown'
                                name="schools"
                                value={schools.value!==null?schools.value:''}
                                placeholder='Select school'
                                options={schools.options}
                                onChange={handleSchoolChange}
                                getOptionLabel={x => x.name}
                                getOptionValue={x => x.id}
                            />
                            {schools.error.length > 0 && <small className="invalid-field text-danger fw-semibold mt-1">{schools.error}</small>}
                        </div>

                        {isOtherSchool &&
                        <div className="col-md-6 mb-3">
                            <label className="form-label">Enter School Name<span>*</span></label>
                            <input
                            type="text"
                            className="form-control"
                            name="otherSchoolName"
                            placeholder="Other School Name"
                            value={otherSchoolName.value!==null?otherSchoolName.value:'' }
                            disabled={!isOtherSchool}
                            onChange={(e) => setOtherSchoolName({ ...otherSchoolName, value: e.target.value, error: '' })}
                        />
                         {otherSchoolName?.error.length > 0 && <small className="invalid-field text-danger fw-semibold mt-1">{otherSchoolName.error}</small>}

                        </div>
                        }
                        
                        <div className="col-md-6 mb-3">
                            <label className="form-label">Study Center<span>*</span></label>
                            <Select
                                className='search-select-dropdown'
                                name="studyCenter"
                                value={studyCenter.value}
                                placeholder='Select Study Center'
                                options={studyCenter.options}
                                onChange={handleStudyCenterChange}
                                getOptionLabel={x => x.name}
                                getOptionValue={x => x.id}
                            />
                            {studyCenter.error.length > 0 && <small className="invalid-field text-danger fw-semibold mt-1">{studyCenter.error}</small>}
                        </div>

                        <div className="col-md-6 mb-3">
                            <label className="form-label">Course<span>*</span> </label>
                            <Select
                            className='search-select-dropdown'
                            name="courses"
                            value={courses.value}
                            placeholder='Select Course'
                            options={courses.options}
                            onChange={handleCoursesChange}
                            getOptionLabel={x => x.name}
                            getOptionValue={x => x.id}
                            />
                            {courses?.error.length > 0 && <small className="invalid-field text-danger fw-semibold mt-1">{courses.error}</small>}
                        </div>

                        <div className="w-100 border my-3 border-bottom-0"></div>

                        <div className="col-md-6 mb-2">
                            <label className="form-label">Password<span>*</span></label>
                            <input type={showPassword?'text':'password'}  value={password.value} 
                            onChange={(e) =>  {
                                let value = e.target.value
                                value = value.replace(/[ '"&]/g, '')
                                setPassword({...password,value,error:''})
                            }
                            } 
                            className="form-control" placeholder="Enter Password"/>
                            {password?.error.length > 0 && <small className="invalid-field text-danger fw-semibold mt-1">{password.error}</small>}
                        </div>

                        <div className="col-md-6 mb-2">
                            <label  className="form-label">Confirm Password<span>*</span></label>
                            <input
                            type="password"
                            className="form-control"
                            name="confirmPassword"
                            placeholder="Confirm Password"
                            value={confirmPassword.value}
                            onChange={e => {
                                let value = e.target.value
                                value = value.replace(/[ '"&]/g, '')
                                setConfirmPassword({...confirmPassword,value, error:''})
                            }}
                        />
                            {confirmPassword?.error.length > 0 && <small className="invalid-field text-danger fw-semibold mt-1">{confirmPassword.error}</small>}
                        </div>

                        <div className="col-md-12 mb-3">
                            <input className="form-check-input" type="checkbox" id="flexCheckChecked"  onChange={handleViewPassword}/>
                            <label className="form-check-label ms-2" htmlFor="flexCheckChecked">
                            Show Password
                            </label>
                        </div>

                        <div className="w-100 border mt-2 border-bottom-0"></div>

                        <div className="col-md-6 mb-5">
                            {loading ? <button className="btn btn-primary w-100" disabled type="button">
                            <span className="spinner-grow spinner-grow-sm me-2" aria-hidden="true"></span>
                                Processing please wait...</button> : 
                            <button className="btn btn-primary w-100" type="button" onClick={onSubmit}>Continue</button>}
                        </div>

        </form>

        </>
  )
}

export default RegisterForm